<template>
  <div class="client_container" @click="clickClient(item, path)">
    <div class="flicker_div" v-if="item.isFlicker">
      <!-- <div
        style="
          width: 100%;
          height: 0.625rem;
          background-color: white;
          position: absolute;
          bottom: 0;
        "
      ></div> -->
    </div>
    <div :class="{ normal_div: !item.isChecked, normaled_div: item.isChecked }">
      <div
        :class="{ uncheck_tip: !item.isChecked, check_tip: item.isChecked }"
      ></div>
      <div class="unread_div">
        <div class="unread_tip" v-if="item.unread_msg_count > 0"></div>
      </div>
      <div class="right_div">
        <div class="line1_div">
          <div
            :class="{
              address_div: !item.isChecked,
              addressed_div: item.isChecked,
            }"
            v-if="item.region"
          >
            {{ item.region }}
          </div>
          <div v-if="item.isUpdateNike === 1" class="userId_div">
            <div
              :class="{ nick_div: !item.isChecked, nicked_div: item.isChecked }"
            >
              {{ item.nickname }}
            </div>
          </div>
          <div v-else class="userId_div">
            <!-- <div v-if="util.nullToString(item.age) === '' && util.nullToString(item.tel) === '' && util.changeGender(item.gender) === ''" 
						:class="{'nick_div':!item.isChecked, 'nicked_div':item.isChecked}">{{item.nickname}}</div>
						<div :class="{'nick_div':!item.isChecked, 'nicked_div':item.isChecked}">{{util.changeGender(item.gender)}}
						{{util.changeAge(item.age)}}{{util.nullToString(item.tel)}}</div> -->
            <div
              v-if="
                util.nullToString(item.age) === '' &&
                util.changeGender(item.gender) === ''
              "
              :class="{ nick_div: !item.isChecked, nicked_div: item.isChecked }"
            >
              {{ item.nickname }}
            </div>
            <div
              :class="{ nick_div: !item.isChecked, nicked_div: item.isChecked }"
            >
              {{ util.changeGender(item.gender) }}
              {{ util.changeAge(item.age) }}
            </div>
          </div>
          <!-- {{item.isChecked}} -->
          <div class="count_div">
            <span
              ><span class="red_span">{{ item.cmcount }}</span
              >/<span class="blue_span">{{ item.csmcount }}</span
              >/{{ item.numberVisits }}</span
            >
          </div>
          <div class="icon_div" v-if="!item.isChecked">
            <div class="device_div">
              <img
                v-if="item.terminal == 1 || item.terminal == 2"
                src="../../static/talks/t_phone.png"
                style="width: 100%; height: 100%; vertical-align: top"
              />
              <img
                v-else
                src="../../static/talks/t_pc.png"
                style="width: 100%; height: 100%; vertical-align: top"
              />
            </div>
            <div class="brower_div">
              <img
                v-if="item.soruce == 1"
                src="../../static/talks/t_baidu.png"
                style="width: 100%; height: 100%; vertical-align: top"
              />
              <img
                v-else-if="item.soruce == 2"
                src="../../static/talks/t_360.png"
                style="width: 100%; height: 100%; vertical-align: top"
              />
              <img
                v-else-if="item.soruce == 3"
                src="../../static/talks/t_sogu.png"
                style="width: 100%; height: 100%; vertical-align: top"
              />
              <img
                v-else-if="item.soruce == 4"
                src="../../static/talks/t_god.png"
                style="width: 100%; height: 100%; vertical-align: top"
              />
              <img
                v-else-if="item.soruce == 5"
                src="../../static/talks/t_wx.png"
                style="width: 100%; height: 100%; vertical-align: top"
              />
            </div>
          </div>
          <div class="icon_div" v-else>
            <div class="device_div">
              <img
                v-if="item.terminal == 1 || item.terminal == 2"
                src="../../static/talks/t_phoneed.png"
                style="width: 100%; height: 100%; vertical-align: top"
              />
              <img
                v-else
                src="../../static/talks/t_pced.png"
                style="width: 100%; height: 100%; vertical-align: top"
              />
            </div>
            <div class="brower_div" v-if="item.soruce != 0">
              <img
                v-if="item.soruce == 1"
                src="../../static/talks/t_baidued.png"
                style="width: 100%; height: 100%; vertical-align: top"
              />
              <img
                v-else-if="item.soruce == 2"
                src="../../static/talks/t_360ed.png"
                style="width: 100%; height: 100%; vertical-align: top"
              />
              <img
                v-else-if="item.soruce == 3"
                src="../../static/talks/t_sogued.png"
                style="width: 100%; height: 100%; vertical-align: top"
              />
              <img
                v-else-if="item.soruce == 4"
                src="../../static/talks/t_goded.png"
                style="width: 100%; height: 100%; vertical-align: top"
              />
              <img
                v-else-if="item.soruce == 5"
                src="../../static/talks/t_wxed.png"
                style="width: 100%; height: 100%; vertical-align: top"
              />
            </div>
          </div>
        </div>
        <!-- ((item.content && util.nullToString(item.content)) !== '' ||
              (!item.content && util.nullToString(item.query) !== '')) &&
            type !== 4 -->
        <div
          v-if="item.metaQuery && type !== 1"
          :class="{ line2_div: !item.isChecked, line2ed_div: item.isChecked }"
        >
          <span class="line2_text">{{ item.metaQuery }}</span>
        </div>

        <div
          v-if="(item.content || item.query) && type === 1"
          :class="{ line2_div: !item.isChecked, line2ed_div: item.isChecked }"
        >
          <span class="line2_text" v-if="item.content">{{ item.content }}</span>
          <span class="line2_text" v-else>{{ item.query }}</span>
          <img
            class="trusteeship"
            src="../../static/talks/trusteeship.png"
            alt=""
            v-if="item.trusteeship"
          />
        </div>

        <div class="line3_div" v-if="item.labels.length > 0">
          <div v-for="(obj, index) in item.labels" :key="index">
            <div
              class="get_btn"
              :style="{ 'background-color': '#' + obj.color }"
            >
              {{ obj.name }}
            </div>
          </div>
        </div>
        
        <!-- 进度条组件 - 新的一行 -->
        <div class="line4_div" v-if="shouldShowProgress">
          <div class="progress_container">
            <div class="progress_wrapper">
              <div class="progress_bar">
                <div class="progress_fill" :style="{ width: (progressData.rate * 100) + '%' }"></div>
              </div>
              <div class="progress_handle" :style="{ left: (progressData.rate * 100) + 'px' }">
                <img :src="currentEmoji" alt="" class="progress_icon" />
              </div>
            </div>
            <div 
              v-if="progressData.tag && progressData.tag.trim() !== ''" 
              class="progress_label"
              :class="{
                'tag_default': !progressData.tag || progressData.tag === '沟通',
                'tag_curse': progressData.tag === '骂人',
                'tag_ai': progressData.tag === '怀疑AI'
              }"
            >
              {{ progressData.tag }}
            </div>
            <!-- 警告标签 -->
            <div 
              v-if="progressData.warn_tag && progressData.warn_tag.warn_name && progressData.warn_tag.warn_name.trim() !== ''" 
              class="warn_label"
              :class="{
                'warn_general': progressData.warn_tag.warn_level === '一般',
                'warn_urgent': progressData.warn_tag.warn_level === '紧急'
              }"
            >
              {{ progressData.warn_tag.warn_name }}
            </div>
          </div>
        </div>
        <!-- <div class="line3_div" v-if="item.customerStatus !== null">
					<div class="get_btn" :style="{'background-color':'#'+item.customerStatus.color}">{{item.customerStatus.name}}</div>
				</div> -->
        <!-- <div class="line3_div">
					<div class="get_btn" v-if="item.status == '2'">已转潜</div>
					<div class="talk_btn" v-if="item.status == '1'">已开口</div>
					<div class="unorder_btn" v-if="item.status == '3'">未预约</div>
					<div class="order_btn" v-if="item.status == '4'">预约</div>
				</div> -->
      </div>
    </div>
    <!-- <div class="flicker_div" v-if="item.isFlicker"></div> -->
  </div>
</template>

<script>
export default {
  name: "clientItem",

  props: {
    item: {
      type: Object,
    },
    path: {
      type: Number,
    },
    type: {
      type: Number,
    },
  },
  data() {
    return {
      progressData: {
      },
      progressTimer: null, // 定时器
      // 状态映射表 - 基于tag字段
      statusMap: {
        "地址": { name: "地址", emoji: require("../../static/talks/progress_hz.png") },
        "预约": { name: "预约", emoji: require("../../static/talks/progress_dh.png") },
        "费用": { name: "费用", emoji: require("../../static/talks/progress_qb.png") },
        "医保": { name: "医保", emoji: require("../../static/talks/progress_sz.png") },
        "怀疑AI": { name: "怀疑AI", emoji: require("../../static/talks/progress_ai.png") },
        "骂人": { name: "骂人", emoji: require("../../static/talks/progress_sq.png") }
      }
    };
  },
  computed: {
    // 获取当前状态对应的图标
    currentEmoji() {
      const tag = this.progressData.tag;
      return this.statusMap[tag] ? this.statusMap[tag].emoji : require("../../static/talks/progress_chat.png");
    },
    // 获取当前状态对应的标签名称
    currentStatusName() {
      const tag = this.progressData.tag;
      return this.statusMap[tag] ? this.statusMap[tag].name : (this.progressData.tag || "沟通");
    },
    // 是否显示进度条（只有当type=1时显示）
    shouldShowProgress() {
      return this.type === 1;
    }
  },
  methods: {
    clickClient(obj, index) {
      console.log("clientItem clickClient obj = ", obj);
      console.log("clientItem clickClient index = ", index);
      this.$emit("selectClient", obj, index);
    },
    // 获取进度数据
    async getProgressData() {
      try {
        const response = await this.util.postRequest({
          url: '/manager/sessionProgress/getProgress',
          method: 'POST',
          data: {
            sid: this.item.sid || '',
            cid: this.item.cid || this.item.id || ''
          }
        });
        
        if (response.resultCode === '10000' && response.data) {
          console.log('✅ 接口返回的进度数据:', response.data);
          console.log('进度值 rate:', response.data.rate);
          console.log('标签 tag:', response.data.tag);
          
          this.progressData = response.data;
          
          // 检查是否需要播放进度音频
          if (this.progressData.tag === "地址" ||this.progressData.tag === "怀疑AI" || this.progressData.tag === "骂人"  || this.progressData.tag === "预约"  || this.progressData.tag === "费用"  || this.progressData.tag === "医保") {
            this.util.playProgressAudio();
            console.log("🔔 playProgressAudio 触发，tag:", this.progressData.tag);
          }
          
        } else {
          console.error('获取进度数据失败:', response.desc);
        }
      } catch (error) {
        console.error('获取进度数据失败:', error);
      }
    },

    // 开始定时器
    startProgressTimer() {
      // 只有当type=1时才启动定时器
      if (this.type !== 1) {
        return;
      }
      
      if (this.progressTimer) {
        clearInterval(this.progressTimer);
      }
      
      // 立即请求一次
      this.getProgressData();
      
      // 每10秒请求一次
      this.progressTimer = setInterval(() => {
        this.getProgressData();
      }, 10000);
    },
    // 清除定时器
    clearProgressTimer() {
      if (this.progressTimer) {
        clearInterval(this.progressTimer);
        this.progressTimer = null;
      }
    },
  },
  watch: {
    // 监听 store 中的进度更新通知
    '$store.state.progressUpdateNotify': {
      handler(newVal) {
        if (newVal.needUpdate && 
            newVal.cid === this.item.cid && 
            newVal.sid === this.item.sid) {
          console.log('clientItem 收到进度更新通知:', newVal);
          // 立即请求进度数据
          this.getProgressData();
          // 重置通知状态
          this.$store.commit('resetProgressNotify');
        }
      },
      deep: true
    }
  },
  mounted() {
    // 只有当type=1时才启动定时器
    if (this.type === 1) {
      //this.startProgressTimer();
      this.getProgressData();
    }
  },
  beforeDestroy() {
    // 组件销毁前清除定时器
    this.clearProgressTimer();
  },
};
</script>

<style scoped="scoped" lang="scss">
.client_container {
  width: 100%;
  /* height: 5.625rem; */
  // margin-bottom: 0.5rem;
  background-color: #fff;
  display: flex;
  position: relative; /* 为进度条绝对定位提供参考 */
}

.normal_div,
.normaled_div {
  width: 100%;
  /* height: 5.625rem; */
  /* background-color: gold; */
  background-color: #fff;
  display: flex;
  box-sizing: border-box;
  overflow: hidden;
  z-index: 1;
  &:hover {
    background-color: #f2f7ff !important;
  }
}

.normaled_div {
  background-color: #f2f7ff;
  // background-color: #e2e8f0;
}

.flicker_div {
  width: 100%;
  height: 100%;
  // background-color: red; //闪动的底色
  position: absolute;
  left: 0;
  z-index: 2;
  opacity: 0.6;
  // padding-bottom: 10px;
}

.flicker_div {
  -webkit-animation: twinkling alternate 0.6s infinite ease-in-out;
  animation: twinkling alternate 0.6s infinite ease-in-out;
}

.animated {
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}

@-webkit-keyframes twinkling {
  0% {
    // opacity: 0.0;
    background-color: #fff;
  }

  100% {
    // opacity: 0.6;
    background-color: #ef1501;
  }
}

@keyframes twinkling {
  0% {
    // opacity: 0.5;
    background-color: #fff;
    // background-color: #ff6666;
  }
  // 50%{
  //   background-color: #FF0000;
  // }

  100% {
    // opacity: 0.8;
    // background-color:#FF0000;
    background-color: #ef1501;
  }
}

.check_tip,
.uncheck_tip {
  width: 3px;
  flex-shrink: 0;
  /* height: 90px; */
  background: #5a9cf8;
  border-radius: 1px;
}

.uncheck_tip {
  background-color: rgba(234, 181, 67, 0);
}

.unread_div {
  /* background-color: #35B9FF; */
  width: 0.5rem;
  flex-shrink: 0;
  line-height: 100%;
  display: flex;
  align-items: center;
}

.unread_tip {
  width: 0.5rem;
  height: 0.5rem;
  background: #ff714a;
  border-radius: 50%;
  margin: 0 auto;
}

.right_div {
  flex: 1;
  min-width: 0;
  height: 100%;
  box-sizing: border-box;
  padding-right: 8px;
  // background-color: #e2e8f0;
}

.userId_div {
  flex: 1;
  min-width: 0;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.line1_div {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 1.875rem;
  width: 100%;
  min-width: 0;
  box-sizing: border-box;
  //background-color: palevioletred;
}

.address_div,
.addressed_div,
.nick_div,
.nicked_div,
.line2_div,
.line2ed_div,
.count_div {
  @include change_size($font_size_normal);
  font-family: PingFang-SC-Bold, PingFang-SC;
  font-weight: bold;
  color: #444444;
  // display: flex;
  // align-items: center;
}

.address_div,
.addressed_div {
  // width: 3.125rem;
  width: 3em;
  margin-right: 0.3125rem;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  color: #1565c0;
  font-weight: 700;
  //background-color: greenyellow;
}

.nicked_div,
.line2ed_div {
  color: #5a9cf8;
}

.addressed_div {
  color: #0d47a1;
}

.nick_div,
.nicked_div {
  //background-color: cyan;
  // width: 7.5rem;
  width: 100%;
  padding-right: 0.625rem;
  line-height: 1.875rem;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.count_div {
  flex-shrink: 0;
  white-space: nowrap;
  justify-content: center;
}

.icon_div {
  // width: 2.125rem;
  height: 1.875rem;
  flex-shrink: 0;
  //background-color: skyblue;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  margin-left: 0.1875rem;
  // position: absolute;
  // right: 0.625rem;
}

.device_div,
.brower_div {
  width: 14px;
  height: 14px;
  margin-right: 0.1875rem;
}

.line2_div,
.line2ed_div {
  height: 1.875rem;
  min-width: 0;
  text-align: left;
  display: flex;
  align-items: center;
  overflow: hidden;
  white-space: nowrap;
}

.line2_text {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.trusteeship {
  width: 20px;
  height: 20px;
  margin-left: 6px;
  flex-shrink: 0;
  vertical-align: middle;
}

.line3_div {
  display: flex;
  align-items: center;
  margin-bottom: 0.5rem;
  /* background-color: yellow; */
  /* height: 1.875rem; */
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  //background-color: cyan;
}

.get_btn {
  // width: 50px;
  height: 24px;
  background: #5a9cf8;
  border-radius: 2px;
  @include change_tip_size($tip_size_normal);
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #fff;
  margin-right: 0.375rem;
  flex-wrap: wrap;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-left: 0.1875rem;
  padding-right: 0.1875rem;
}

.talk_btn {
  width: 40px;
  height: 20px;
  background: #fbfdff;
  border-radius: 2px;
  border: 1px solid #5a9cf8;
  font-size: 10px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #5a9cf8;
  display: flex;
  align-items: center;
  justify-content: center;
}

.untalk_btn {
  width: 40px;
  height: 20px;
  background: #fbfdff;
  border-radius: 2px;
  border: 1px solid #444444;
  font-size: 10px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #444444;
  display: flex;
  align-items: center;
  justify-content: center;
}

.order_btn {
  width: 40px;
  height: 20px;
  background: #fbfdff;
  border-radius: 2px;
  border: 1px solid #ff7b7b;
  font-size: 10px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ff7b7b;
  display: flex;
  align-items: center;
  justify-content: center;
}

.unorder_btn {
  width: 40px;
  height: 20px;
  background: #fbfdff;
  border-radius: 2px;
  border: 1px solid #d9dae2;
  font-size: 10px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #d9dae2;
  display: flex;
  align-items: center;
  justify-content: center;
}

.red_span {
  color: #f85a5a;
}

.blue_span {
  color: #5a9cf8;
}

/* 进度条行样式 */
.line4_div {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-bottom: 0.5rem;
  margin-top: 0.25rem;
  width: 100%;
  min-height: 24px;
}

/* 进度条容器样式 */
.progress_container {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
}

/* 进度条包装器 */
.progress_wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

/* 进度条样式 */
.progress_bar {
  width: 100px;
  height: 8px;
  background: linear-gradient(90deg, #00d4ff 0%, #5a9cf8 30%, #8b5cf6 60%, #ff6b9d 100%);
  border-radius: 4px;
  overflow: hidden;
}

/* 进度条填充 */
.progress_fill {
  height: 100%;
  background: linear-gradient(90deg, #00d4ff 0%, #5a9cf8 30%, #8b5cf6 60%, #ff6b9d 100%);
  border-radius: 4px;
  transition: width 0.3s ease;
}

/* 进度条手柄（图标） */
.progress_handle {
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 20px;
  height: 20px;
  background: #fff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
  z-index: 2;
  transition: left 0.3s ease;
}

/* 进度条图标 */
.progress_icon {
  width: 16px;
  height: 16px;
  object-fit: contain;
}

/* 标签样式 */
.progress_label {
  background: #ff7b00;
  color: #fff;
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 500;
  white-space: nowrap;
  box-shadow: 0 1px 4px rgba(255, 123, 0, 0.3);
  min-width: fit-content;
  flex-shrink: 0;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease;
}

/* tag 为空或"沟通" - 浅蓝色 */
.progress_label.tag_default {
  background: #5a9cf8;
  box-shadow: 0 1px 4px rgba(90, 156, 248, 0.3);
}

/* tag 为"骂人" - 红色 */
.progress_label.tag_curse {
  background: #ff4444;
  box-shadow: 0 1px 4px rgba(255, 68, 68, 0.3);
}

/* tag 为"怀疑AI" - 浅红色 */
.progress_label.tag_ai {
  background: #ff7b7b;
  box-shadow: 0 1px 4px rgba(255, 123, 123, 0.3);
}

/* 警告标签样式 */
.warn_label {
  padding: 4px 8px;
  border-radius: 10px;
  font-size: 10px;
  font-weight: 600;
  white-space: nowrap;
  min-width: fit-content;
  flex-shrink: 0;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease;
  animation: warningBlink 0.8s infinite;
  margin-left: 6px;
}

/* 一般警告样式 */
.warn_general {
  background: #ffa500;
  color: #fff;
  box-shadow: 0 1px 4px rgba(255, 165, 0, 0.4);
}

/* 紧急警告样式 */
.warn_urgent {
  background: #ff4444;
  color: #fff;
  box-shadow: 0 1px 4px rgba(255, 68, 68, 0.4);
}

/* 警告闪烁动画 */
@keyframes warningBlink {
  0% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.7;
    transform: scale(1.05);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}

html[data-compact="1"] {
  .line1_div,
  .line2_div,
  .line2ed_div,
  .icon_div {
    height: 22px;
  }
  .line2_text {
    line-height: 22px;
  }
  .nick_div,
  .nicked_div {
    line-height: 22px;
    padding-right: 4px;
  }
  .address_div,
  .addressed_div,
  .nick_div,
  .nicked_div,
  .line2_div,
  .line2ed_div,
  .count_div {
    font-size: 12px !important;
  }
  .device_div,
  .brower_div {
    width: 10px;
    height: 10px;
  }
  .right_div {
    padding-right: 6px;
  }
  .unread_div {
    width: 6px;
  }
  .trusteeship {
    width: 12px;
    height: 12px;
    margin-left: 6px;
  }
  .progress_icon {
    width: 12px;
    height: 12px;
  }
  .line3_div {
    margin-bottom: 4px;
  }
  .get_btn {
    height: 16px;
    padding: 0 5px;
    margin-right: 4px;
    font-size: 10px !important;
    line-height: 16px;
  }
  .talk_btn,
  .untalk_btn,
  .order_btn,
  .unorder_btn {
    width: auto;
    min-width: 32px;
    height: 16px;
    font-size: 10px;
    padding: 0 4px;
  }
  .progress_label {
    padding: 0 6px;
    height: 16px;
    line-height: 16px;
    font-size: 10px;
    border-radius: 8px;
  }
  .warn_label {
    padding: 0 6px;
    height: 16px;
    line-height: 16px;
    font-size: 10px;
    margin-left: 4px;
  }
  .line4_div {
    min-height: 18px;
    margin-top: 2px;
    margin-bottom: 4px;
  }
  .progress_bar {
    width: 80px;
    height: 6px;
  }
  .progress_handle {
    width: 16px;
    height: 16px;
  }
}
</style>
